import * as React from "react";
import { forwardRef } from "react";
const SvgSelectArrows = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M8.25 16L12 19.75L15.75 16M8.25 10L12 6.25L15.75 10" }));
const ForwardRef = forwardRef(SvgSelectArrows);
export default ForwardRef;
